import i18n from '../config'
import { useStore } from '@/core'
import { useTranslation } from 'react-i18next'

const decodeHtmlEntities = (str) => {
  const element = document.createElement('div')
  
  element.innerHTML = str
  
  return element.textContent || element.innerText || ''
}

export const causeTranslator = (causeString) => {
  if (i18n.language === 'en') {
    return causeString
  }

  const causesInEnglish = Object.entries(
    i18n.getResource('en', 'translation', 'causes')
  )
  const foundEntry = causesInEnglish.find(([_, value]) => value === causeString)

  if (!foundEntry) {
    return causeString
  }

  const [key] = foundEntry
  return i18n.t(`causes.${key}`, { lng: i18n.language })
}

export const causeAwarenessDateTranslator = (awarenessDateString) => {
  if (i18n.language === 'en') {
    return awarenessDateString
  }

  const datesInEnglish = Object.entries(
    i18n.getResource('en', 'translation', 'causeAwarenessDates')
  )
  const foundEntry = datesInEnglish.find(
    ([_, value]) => value === awarenessDateString
  )

  if (!foundEntry) {
    return awarenessDateString
  }

  const [key] = foundEntry
  const translation = i18n.t(`causeAwarenessDates.${key}`, {
    lng: i18n.language,
  })
  return decodeHtmlEntities(translation)
}
